import React from "react";

// ✅ Replace this with your real image later
import heroImg from "../../Images/side-1.png";

const COLORS = {
  navyA: "#040811",
  navyB: "#070a14",
  lime: "#C9F06B",
  text: "#FFFFFF",
  muted: "rgba(255,255,255,0.75)",
};

const steps = [
  {
    n: "1",
    title: "Analyse Ihrer Prozesse",
    desc: "Wir schauen uns Ihre Abläufe an und identifizieren die größten Zeit-und Kostenfresser.",
  },
  {
    n: "2",
    title: "Entwicklung individueller\nKI-Automatisierungen",
    desc: "Maßgeschneiderte KI-Agenten statt Standard-Tools – exakt passend zu Ihrem Use Case.",
  },
  {
    n: "3",
    title: "Integration & laufende Optimierung",
    desc: "Nahtlose Integration in Ihre Systeme und kontinuierliche Optimierung der Automationen.",
  },
];

export default function OurProccess() {
  return (
    <section className="bg-white w-[90%] 2xl:w-[70%] mx-auto">
      {/* Card wrapper (keeps the original dark design, while page background stays white) */}
      <div
        className="mx-auto w-full  overflow-hidden rounded-[28px] shadow-[0_18px_60px_rgba(0,0,0,0.18)]"
        style={{
          background: `radial-gradient(900px 500px at 15% 15%, rgba(14, 22, 37, 0.12), transparent 55%),
                       radial-gradient(700px 420px at 85% 25%, rgba(201,240,107,0.12), transparent 55%),
                       linear-gradient(135deg, ${COLORS.navyA} 0%, ${COLORS.navyB} 70%)`,
        }}
      >
        <div className="grid items-center gap-10 px-7 py-10 md:grid-cols-2 md:gap-8 md:px-12 md:py-14">
          {/* LEFT */}
          <div className="text-white">
            <h2 className="h2-mb h2-md h2-lg h2-2xl !text-white">
              Ihre Prozesse. Unsere KI.
              <br />
              Vollautomatisch.
            </h2>

            <p
              className="mt-5 max-w-xl text-base leading-7 md:text-[15.5px]"
              style={{ color: COLORS.muted }}
            >
              Wir analysieren Ihre Abläufe und automatisieren alles,
              <br className="hidden md:block" />
              was heute manuell Zeit und Geld kostet –
              <br className="hidden md:block" />
              mit maßgeschneiderten KI-Agenten und Automationen.
            </p>

            <div className="mt-8">
              <div
                className="text-sm font-semibold tracking-wide"
                style={{ color: COLORS.lime }}
              >
                Ablauf (3 Schritte)
              </div>

              {/* Steps */}
              <div className="relative mt-6">
                {/* Vertical rail */}
                <div className="absolute left-[18px] top-0 h-full w-px bg-white/20" />

                <div className="space-y-7">
                  {steps.map((s, idx) => (
                    <div key={s.n} className="relative flex gap-5">
                      {/* Number bubble */}
                      <div className="relative">
                        <div
                          className="grid h-9 w-9 place-items-center rounded-full text-sm font-bold"
                          style={{
                            background: `linear-gradient(180deg, rgba(201,240,107,0.95), rgba(160,220,70,0.95))`,
                            color: "#0B1633",
                            boxShadow:
                              "0 0 0 6px rgba(201,240,107,0.08), 0 10px 25px rgba(201,240,107,0.18)",
                          }}
                        >
                          {s.n}
                        </div>
                      </div>

                      {/* Text */}
                      <div className="pt-0.5">
                        <div className="text-[20px] font-semibold leading-snug md:text-[22px]">
                          {s.title.split("\n").map((line, i) => (
                            <React.Fragment key={i}>
                              {line}
                              {i === 0 && s.title.includes("\n") ? <br /> : null}
                            </React.Fragment>
                          ))}
                        </div>
                        <p
                          className="mt-2 max-w-xl text-sm leading-6"
                          style={{ color: COLORS.muted }}
                        >
                          {s.desc}
                        </p>
                      </div>

                      {/* spacing line cutoff for last item */}
                      {idx === steps.length - 1 ? (
                        <div className="absolute left-[18px] top-9 h-[999px] w-px bg-transparent" />
                      ) : null}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT (Image/Illustration placeholder) */}
          <div className="relative">
            {/* Glow backdrop */}
            <div
              className="pointer-events-none absolute -inset-6 rounded-[34px] blur-2xl"
              style={{
                background:
                  "radial-gradient(closest-side at 60% 40%, rgba(201,240,107,0.22), transparent 70%)",
              }}
            />

            {/* Placeholder frame (replace with <img /> later) */}
            <div className="relative overflow-hidden rounded-[26px] border border-white/10 bg-white/5 p-3 shadow-[0_20px_70px_rgba(0,0,0,0.35)]">
              <div className="relative  w-full overflow-hidden rounded-[20px] border border-white/10 bg-gradient-to-br from-white/5 to-white/0">
                {/* Replace this block with your image */}
                <img
                  src={heroImg}
                  alt="Automation Illustration"
                  className="h-full w-full object-cover"
                />

                
                {/* Subtle dots */}
               
              </div>

              {/* Neon rim */}
              <div
                className="pointer-events-none absolute -inset-[2px] rounded-[28px] opacity-60"
                style={{
                  background:
                    "linear-gradient(140deg, rgba(201,240,107,0.35), transparent 35%, rgba(59,130,246,0.18), transparent 70%)",
                  maskImage:
                    "linear-gradient(#000, #000) content-box, linear-gradient(#000, #000)",
                  WebkitMaskImage:
                    "linear-gradient(#000, #000) content-box, linear-gradient(#000, #000)",
                  padding: 2,
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
